import API from '../api';
import jwtDecode from 'jwt-decode';

function getTokenData() {
  const token = localStorage.getItem('access_token');
  const { user_id, business_id } = jwtDecode(token);
  return { user_id, business_id };
}

export default class {
  static async list(title) {
    const { business_id } = getTokenData();
    const { data } = await API.get('/riskSurvey', {
      headers: { business_id },
      params: title ? { title } : undefined,
    });
    return data.data;
  }

  static async create(payload) {
    const { user_id, business_id } = getTokenData();
    const { data } = await API.post('/riskSurvey', {
      ...payload,
      business_id,
      author_id: user_id,
    });
    return data;
  }

  static async update(id, payload) {
    const { user_id, business_id } = getTokenData();
    const { data } = await API.put(`/riskSurvey/${id}`, payload, {
      headers: { business_id, author_id: user_id },
    });
    return data;
  }

  static async remove(id) {
    await API.delete(`/riskSurvey/${id}`);
  }

  static async downloadGeneralPdf(id) {
    const response = await API.get(`/riskSurvey/pdf/${id}`, {
      responseType: 'blob',
    });
    return response.data;
  }

  static async downloadCategoryPdf(id, categories) {
    const response = await API.post(
      `/riskSurvey/${id}/category-report/pdf`,
      { categories },
      { responseType: 'blob' },
    );
    return response.data;
  }

  static async compare(targetOne, targetTwo) {
    const { data } = await API.post('/riskSurvey/comparison', { targetOne, targetTwo });
    return data;
  }

  static async downloadComparePDF(targetOne, targetTwo) {
    const response = await API.post(
      '/riskSurvey/comparison/pdf',
      { targetOne, targetTwo },
      { responseType: 'blob' },
    );
    return response.data;
  }

  static async getSurveySegmentFilters (surveyId, params = {}) {
    const { data } = await API.get(`/riskSurvey/${surveyId}/segment-filters`, { params });
    return data.data;
  }

}
